// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SecondaryFooter_Wrapper__2bqkR","Text":"SecondaryFooter_Text__HCCIq","Link":"SecondaryFooter_Link__2JZnb"};